<template>
  <div class="common-date-status">
    <common-slide-calendar
      class="bg-FFFFFF"
      @getDate="methodGetDate"
      :with-status="true"
      :status-list="dateExceed ? [] : statusList"
      timeFormat="YYYYMMDD"
      :default-date="computedDate"
      @changeCalendarType="changeCalendarType"
      @onTransitionEnd="onTransitionEnd"
      ref="calendar"
    >
      <div
        slot="title"
        class="p-16-0 bb fb fb-cross-center c-171A1D font-28 p-0-16"
      >
        <span>{{ computedTimeStr }}</span>
      </div>
    </common-slide-calendar>
    <div
      v-if="signTimeDtoList && !dateExceed"
      class="bg-FFFFFF p-0-16 pt-20"
      ref="timeList"
    >
      <span
        class="font-26 c-171A1D-56 mb-4 inline-block"
        v-for="(item, index) in signTimeDtoList"
        :key="item.signTimePeriodId"
      >
        {{ inOutType[+item.inOutType] }}：{{ item.signStartTime }}-{{
          `${
            +item.signStartTime.replace(':', '') >=
            +item.signEndTime.replace(':', '')
              ? '次日'
              : ''
          }${item.signEndTime}`
        }}；<br v-if="index % 2 !== 0"
      /></span>
    </div>
    <div
      class="bg-FFFFFF p-0-16 font-28 bd-radio-4 pt-16"
      ref="leaveList"
      v-if="askForLeave.length && !dateExceed"
    >
      <div
        class="fb fb-main-between p-12-0 pl-12 fb-cross-center bg-F9F9F9"
        :class="{ bt: index > 0 }"
        v-for="(item, index) in askForLeave"
        @click="handlerRouter(item)"
        :key="index"
      >
        <div class="fb fb-cross-baseline font-34">
          <span class="iconfont c-FF9F00 mr-7">&#xe688;</span>
          <div>
            <div class="fb fb-cross-center">
              <span class="c-171A1D ff-medium lh-24 mb-4"
                >{{ item.leaveTypeName }}
              </span>
              <span class="ml-4 c-171A1D-60"
                >({{
                  `${parseFloat(item.leaveDuration).toFixed(1)}${
                    item.leaveDurationUnit === 1 ? '小时' : '天'
                  }`
                }})</span
              >
            </div>
            <p class="font-26 c-171A1D-56">{{
              methodTransfromTime(item)[0]
            }}</p>
          </div>
        </div>
        <span class="iconfont font-28 c-171A1D-40 mr-20">&#xe66b;</span>
      </div>
    </div>
    <div
      ref="stepList"
      class="bg-FFFFFF pt-20 pl-22 pr-16"
      v-if="list.length && !dateExceed"
    >
      <div
        class="detail-content"
        v-for="(item, index) in list"
        v-show="computedIsCheckInRecked"
        :key="index"
      >
        <common-step
          :show-line="
            !(
              ix === item.dormRecordsDtoList.length - 1 &&
              index === list.length - 1
            )
          "
          :icon="1"
          class=""
          v-show="computedIsCheckInRecked"
          v-for="(it, ix) in item.dormRecordsDtoList"
          :key="ix"
        >
          <span slot="title">
            <span
              class="pl-8 text-bold"
              v-if="[0, 8, 9, 10, 11, 12].indexOf(it.dormState) < 0"
            >
              <span class="pr-8 p-4-0 ff-medium">{{
                inOutType[+item.inOutType]
              }}</span>
              <span class="p-4-0">{{ it.signTime }}</span>
            </span>
            <span
              v-else
              class="c-171A1D-56 font-26 p-5-0 pl-8"
              v-html="`${it.signTime}`"
            ></span>
          </span>
          <div slot="main" class="pl-10 pb-50">
            <div
              class="c-171A1D-56 font-26 fb fb-cross-center mt-12 pl-12"
              v-if="!it.dormState || ~[8, 9, 10, 11, 12].indexOf(it.dormState)"
            >
              <i class="iconfont font-32 c-171A1D-56 mr-5">&#xe680;</i>
              {{
                calculdateState(
                  it.signTime,
                  item.inOutType,
                  ~[8, 9].indexOf(it.dormState),
                  it.dormState
                )
              }}
            </div>
            <div
              v-if="it.deviceName"
              class="font-26 pl-12 fb fb-cross-center c-171A1D-56 mt-12"
            >
              <i class="iconfont font-32 mr-5">&#xe689;</i>
              <span
                >{{ it.deviceName
                }}{{
                  `${it.deviceInOutType}` === '1'
                    ? ' (进)'
                    : `${it.deviceInOutType}` === '2'
                    ? ' (出)'
                    : ''
                }}</span
              >
            </div>
            <div
              v-if="it.dormState !== 0"
              class="pl-12 font-26 fb fb-main-between fb-cross-center"
            >
              <div>
                <span
                  class="inline-block tag-abnormal lh-22 bg-FF9D16 p-0-10 bd-radio-9999 mt-12"
                  v-if="it.dormState === 5 || it.dormState === 6"
                  >请假</span
                >
                <span
                  class="inline-block tag-abnormal lh-22 p-0-10 bd-radio-9999 mt-12"
                  v-if="it.dormState === 1 || it.dormState === 3"
                  >未打卡</span
                >
              </div>
              <div
                class="c-006AFE bd-radio-9999 modifyEnd font-24"
                v-if="it.allowModify"
                @click="handleChangeToNormal(it, item.signTimePeriodId)"
                >修改为正常</div
              >
            </div>
            <div v-if="it.oldState" class="pl-12 mt-12 font-26 c-171A1D-60">
              {{ `${it.operatorUserName}在${it.operatorTime}将未打卡改为正常` }}
            </div>
            <div v-if="it.catchImageUrl" class="pl-12 mt-12">
              <div class="w-50 h-50 bd-radio-4 hidden">
                <img
                  width="50"
                  :src="it.catchImageUrl"
                  alt=""
                  @click="methodEnlargeImg(it.catchImageUrl)"
                />
              </div>
            </div>
          </div>
        </common-step>
      </div>
    </div>
    <div
      class="noData fb fb-main-center fb-cross-center text-center bg-FFFFFF"
      v-if="dateExceed"
      :style="{ height: `${tipsHeight}px` }"
    >
      <div class="fb fb-col c-171A1D-40">
        <span class="iconfont font-140 c-171A1D-12">&#xe68b;</span>
        <p class="font-26 mt-16 text-center mt-16">超出可查看的统计日期范围</p>
      </div>
    </div>
    <template v-else>
      <div
        class="noData fb fb-main-center fb-cross-center text-center bg-FFFFFF"
        v-if="!computedIsCheckInRecked && status"
        :style="{ height: `${tipsHeight}px` }"
      >
        <div class="fb fb-col c-171A1D-40">
          <span class="iconfont font-140 c-171A1D-12">&#xe68b;</span>
          <p class="font-26 mt-16 text-center mt-16">当天暂无打卡记录</p>
        </div>
      </div>
      <div
        class="haveARest fb fb-main-center fb-cross-center text-center bg-FFFFFF"
        v-if="!status"
        :style="{ height: `${tipsHeight}px` }"
      >
        <div class="fb fb-col c-171A1D-40">
          <span class="iconfont font-140 c-171A1D-12">&#xe68c;</span>
          <p class="font-26 mt-16 text-center mt-12">当天为休息日</p>
        </div>
      </div>
    </template>
    <commonImgEnlarge
      :img="enlargeImgUrl"
      v-model="enlargeImgUrl"
    ></commonImgEnlarge>
  </div>
</template>
<script>
import commonSlideCalendar from './commonSlideCalendar'
import commonImgEnlarge from './commonImgEnlarge'
import { unitDayTime, debounce, timeFormat, getItem } from '@/utils/comUtils'
import { mcConfirm } from '@/utils/mcSdkUtils'
import API from '../api'
import commonStep from './commonStep'
import mixin from '@/mixin'
export default {
  mixins: [mixin],
  props: {
    student: {
      // 学生信息
      type: Object,
      default: () => {
        return {}
      }
    },
    dimDay: {
      type: String,
      default: timeFormat(new Date(), 'YYYYMMDD')
    },
    height: {
      type: Number,
      default: 200
    }
  },
  components: {
    commonSlideCalendar,
    commonImgEnlarge,
    commonStep
  },
  computed: {
    computedTimeStr() {
      return timeFormat(this.startDate, 'YYYY年MM月')
    },
    computedDate() {
      return this.dateConvert(this.dimDay)
    },
    computedIsCheckInRecked() {
      // 是否有打卡记录有两种：1.没有打卡 2.到了打卡日期但是没有打卡，可以显示日期
      let isCheckInRecked = true
      if (!this.list.length) {
        isCheckInRecked = false
      } else if (
        this.list.length === 1 &&
        !this.list[0].dormRecordsDtoList.length
      ) {
        isCheckInRecked = false
      } else {
        let isEmpty = this.list.every(stamp => {
          return !stamp.dormRecordsDtoList.length
        })
        if (isEmpty) {
          isCheckInRecked = false
        }
      }
      return isCheckInRecked
    }
  },
  watch: {
    selectedDate: {
      immediate: true,
      handler() {
        this.getUserDormReport()
      }
    }
  },
  data() {
    return {
      enlargeImgUrl: '',
      list: [],
      askForLeave: [],
      signTimeDtoList: [],
      status: 1,
      realCampusId: getItem('currentCapmusId'),
      inOutType: {
        1: '归寝',
        2: '离寝'
      },
      // 0: 无效打卡 1: 未离寝 2: 已离寝 3: 未归寝 4: 已归寝 5: 离寝请假 6: 归寝请假
      allStatus: [
        '无效打卡',
        '未离寝',
        '已离寝',
        '未归寝',
        '已归寝',
        '离寝请假',
        '归寝请假'
      ],
      statusList: [],
      selectedDate: this.dimDay,
      calendarType: 0,
      tipsHeight: 240,
      startDate: new Date(),
      dateExceed: false
    }
  },
  methods: {
    // 跳转页面
    handlerRouter(item) {
      this.$router.push({
        path: '/leave/detail',
        query: {
          leaveId: item.leaveId
        }
      })
    },
    // 时间格式化
    methodTransfromTime(time) {
      let _time = []
      if (+time.leaveDurationUnit === 2) {
        let _start = new Date(time.start.replace(/-/gi, '/'))
        let _end = new Date(time.end.replace(/-/gi, '/'))
        let _unitDayTime = unitDayTime(+_start, +_end)
        let _seg = ((_end - _start) / (24 * 60 * 60 * 1000)).toFixed(1)
        _time[0] = `${_unitDayTime[0]}～${_unitDayTime[1]}`
        _time[1] = `${_seg}天`
      } else {
        let _start = time.start.replace(/-/g, '.')
        let _end = time.end.replace(/-/g, '.')
        const _HOURS = (time.period / 60).toFixed(1)
        _time[0] = `${_start}～${_end}`
        _time[1] = `${_HOURS}小时`
      }

      return _time
    },
    // 判断是否有打卡记录，以便显示是否需要显示打卡机
    methodGetDate(date) {
      this.selectedDate = date
    },
    onTransitionEnd({ date, calendarType, exceed }) {
      this.calendarType = calendarType
      this.startDate = new Date(date.slice(0, 4), +date.slice(4, 6) - 1, 1)
      this.dateExceed = exceed
      this.setHeight()
      if (exceed) {
        return
      }
      if (date.slice(0, 6) !== this.selectedDate.slice(0, 6)) {
        this.selectedDate = date
      }
      debounce(this.getUserDormCalendar)()
    },
    methodEnlargeImg(url) {
      this.enlargeImgUrl = url
    },
    // 日期补0
    methodAddZero(time) {
      if (time < 10) {
        return `0${time}`
      }
      return time
    },
    getUserDormCalendar(
      dimDate = this.selectedDate,
      dateType = this.calendarType
    ) {
      let _yearMonth = this.selectedDate
      let year = new Date().getFullYear()
      let month = `0${new Date().getMonth() + 1}`.slice(-2)
      let day = `0${new Date().getDate()}`.slice(-2)
      if (
        +_yearMonth < +`${year - 1}${month}${day}` ||
        +_yearMonth > +`${year}${month}${day}`
      ) {
        return false
      }
      if (!dateType) {
        let startDate = this.dateConvert(dimDate)
        startDate.setDate(
          startDate.getDate() -
            (startDate.getDay() === 1 ? 0 : startDate.getDay() - 1)
        )
        API.getDormWeekCalendar({
          campusId:
            this.realCampusId ||
            this.$store.getters.currentCapmus.tpId ||
            this.student.campusId ||
            '',
          dingDeptId: this.student.dingDeptId,
          dingUserId: this.student.dingUserId,
          startDimDay: timeFormat(startDate, 'YYYYMMDD')
        })
          .then(res => {
            this.statusList = res || []
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      } else {
        API.getUserDormCalendar({
          campusId:
            this.realCampusId ||
            this.$store.getters.currentCapmus.tpId ||
            this.student.campusId ||
            '',
          dingDeptId: this.student.dingDeptId,
          dingUserId: this.student.dingUserId,
          dimMonth: dimDate.substring(0, 6)
        })
          .then(res => {
            this.statusList = res || []
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      }
    },
    changeCalendarType({ date, calendarType, startDate, exceed }) {
      this.selectedDate = date
      this.calendarType = calendarType
      this.startDate = new Date(
        startDate.slice(0, 4),
        +startDate.slice(4, 6) - 1,
        1
      )
      this.setHeight()
      this.dateExceed = exceed
      if (exceed) {
        return
      }
      debounce(this.getUserDormCalendar)()
    },
    getUserDormReport(date = this.selectedDate) {
      let _yearMonth = this.selectedDate
      let year = new Date().getFullYear()
      let month = `0${new Date().getMonth() + 1}`.slice(-2)
      let day = `0${new Date().getDate()}`.slice(-2)
      if (
        +_yearMonth < +`${year - 1}${month}${day}` ||
        +_yearMonth > +`${year}${month}${day}`
      ) {
        return false
      }
      API.getUserDormReport({
        campusId:
          this.realCampusId ||
          this.$store.getters.currentCapmus.tpId ||
          this.student.campusId ||
          '',
        dimDay: date,
        dingUserId: this.student.dingUserId,
        dingDeptId: Number(this.student.dingDeptId)
      })
        .then(res => {
          let result = res || {}
          this.status = result.signRestStatus || 0
          this.askForLeave = result.leaves || []
          this.signTimeDtoList = result.signTimeDtoList || []

          this.list = (result.dingUserSignRecordTimeDtoList || [])
            .map(item => {
              if (item.modifyDTO) {
                item.modifyDTO.dormState = item.modifyDTO.newState
                item.modifyDTO.signTime = item.signEndTime
                item.modifyDTO.operatorTime = timeFormat(
                  new Date(item.modifyDTO.operatorTime),
                  'hh:mm'
                )
                let dormRecordsDtoList = item.dormRecordsDtoList || []
                dormRecordsDtoList.unshift(item.modifyDTO)
                item.dormRecordsDtoList = dormRecordsDtoList
              }
              item.dormRecordsDtoList.forEach(dt => {
                dt.allowModify =
                  (dt.dormState === 1 || dt.dormState === 3) &&
                  !item.modifyDTO &&
                  (this.curIsAdmin || this.curIsDormAdmin) &&
                  this.selectedDate.substring(0, 6) ===
                    timeFormat(new Date(), 'YYYYMM')
              })
              return item
            })
            .filter(item => item.dormRecordsDtoList.length)
          this.setHeight()
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
    },
    dateConvert(date) {
      return new Date(
        `${date.substring(0, 4)}/${date.substring(4, 6)}/${date.substring(
          6,
          8
        )} 00:00`
      )
    },
    setHeight() {
      this.$nextTick(() => {
        let timeListHeight = (this.$refs.timeList || {}).clientHeight || 0
        let leaveListHeight = (this.$refs.leaveList || {}).clientHeight || 0
        let stepListHeight = (this.$refs.stepList || {}).clientHeight || 0
        this.tipsHeight = Math.min(
          this.height -
            this.$refs.calendar.$el.offsetHeight -
            10 -
            timeListHeight -
            leaveListHeight -
            stepListHeight,
          240
        )
      })
    },
    calculdateState(_signTime, inOutType, invalid = false, state) {
      if (!this.signTimeDtoList.length) {
        return `无效打卡，未在考勤时间内打卡`
      }
      let _current = new Date()
      let rs = this.signTimeDtoList.some(item => {
        let startTime = new Date(
          `${timeFormat(_current, 'YYYY/MM/DD')} ${item.signStartTime}`
        )
        let endDate = new Date(_current.getTime())
        if (
          +item.signEndTime.replace(':', '') <
          +item.signStartTime.replace(':', '')
        ) {
          endDate.setDate(endDate.getDate() + 1)
        }
        let endTime = new Date(
          `${timeFormat(endDate, 'YYYY/MM/DD')} ${item.signEndTime}`
        )
        let signDate = new Date(_current.getTime())
        signDate.setDate(
          signDate.getDate() +
            +(
              +_signTime.replace(':', '') < +item.signStartTime.replace(':', '')
            )
        )
        let signTime = new Date(
          `${timeFormat(signDate, 'YYYY/MM/DD')} ${_signTime}`
        )
        return signTime >= startTime && signTime <= endTime
      })
      const INVALID_TEXT = {
        10: '无效打卡，已离开寝室',
        11: '无效打卡，已进入寝室',
        12: '无效打卡，未在指定设备打卡'
      }
      // ${this.inOutType[+inOutType]}时间
      let msg = rs
        ? INVALID_TEXT[+state] || `无效打卡，以最早打卡时间为准`
        : `无效打卡，未在考勤时间内打卡`
      return !invalid ? msg : '无效打卡'
    },
    handleChangeToNormal(it, signTimePeriodId) {
      mcConfirm({
        msg: '确认修改考勤结果？修改后，考勤时间改为当次考勤的结束时间',
        closeOnPopstate: false
      })
        .then(async btnIndex => {
          if (btnIndex === 1) {
            // 调用接口
            API.modifySignRecord({
              campusId:
                this.realCampusId ||
                this.$store.getters.currentCapmus.tpId ||
                this.student.campusId ||
                '',
              dimDay: this.selectedDate,
              dingUserId: this.student.dingUserId,
              signState: it.signState,
              signTimePeriodId
            })
              .then(res => {
                if (res && res.result && res.result !== '0') {
                  this.$Toast({
                    type: 'fail',
                    content: res.message
                  }).show()
                }
                // 重新获取下打卡日历和状态
                this.getUserDormCalendar()
                this.getUserDormReport()
              })
              .catch(err =>
                this.$Toast({
                  type: 'fail',
                  content: err.message
                }).show()
              )
          }
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
    }
  },
  mounted() {
    this.getUserDormCalendar()
  }
}
</script>
<style lang="scss" scoped>
.noData img,
.haveARest img {
  margin: 0 auto;
  height: 60px;
  width: 60px;
}
.line-left {
  display: inline-block;
  border-left: 2px solid #b4b4b4;
  position: absolute;
  top: 7px;
  left: -1px;
  z-index: 1;
  width: 2px;
  height: 100%;
}
.detail-tag {
  top: 0px;
  left: -7px;
  z-index: 2;
}
.detail-inner-tag {
  top: 0;
  left: -4px;
  z-index: 2;
}
// .detail-content:last-child {
//   .detail-box:last-child {
//     .line-left {
//       display: none;
//     }
//   }
// }
.tag-abnormal {
  background: #fdf2de;
  color: #ff9f00;
}
.tag-normal {
  background: #def5e9;
  color: #00b853;
}
.modifyEnd {
  display: inline-block;
  padding: 3px 8px;
  border: 1px solid;
}
</style>
